<template>
  <a-card :bordered="false">
    <a-table
      rowKey="id"
      :columns="columns"
      :dataSource="list"
      class="j-table-force-nowrap">
    </a-table>
  </a-card>
</template>

<script>
import { getAction } from '@api/manage'

export default {
  name: 'OrderIndex',

  data(){
    return{
      //表单禁用
      props: {
        disabled: {
          default: false
        }
      },
      columns: [
        {
          title:'订单编号',
          align:"center",
          dataIndex: 'id'
        },
        {
          title:'订单内容',
          align:"center",
          dataIndex: 'content'
        },
        {
          title:'创建时间',
          align:"center",
          dataIndex: 'createTime'
        },
      ],
      url: {
        list:"/orderInfoLog/orderInfoLog/getOrderInfoLog",
      },
      list:{},

    }

  },
  created() {
    this.getIndex(this.$route.params.id);
  },
  computed: {
    title () {
      return this.$route.meta.title
    }
  },
  methods:{
    getIndex(id){
      let param = {};
      param.order_info_id = id
      getAction(this.url.list,param).then(res=>{
        this.list = res.result;
      })
    },

  }



}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>